<mat-card *ngIf="SpraAmcvParams.length>0">
    <mat-card-title class="font-weight-bold caption-color">AMCV</mat-card-title>
    <mat-divider></mat-divider>
    <mat-card-content class="pt-2">        
        <div class="row">
            <div class="col-sm-6">
                <div class="form-group row text-left">
                    <label class="col-sm-4 col-form-label">
                        Service Contract Period <span class="font-red-flamingo">(In Year)</span>
                    </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control" type="number" name="txtMachineLife"  (input)="MachineLifeChange()"  [(ngModel)]="MachineLife">
                            <h4 class="col-sm-8">                                  
                                <span *ngIf="ProfitTag" class="badge badge-pill badge-primary ml-2" (click)="RecalculatePLDetail(true)"> Recalculate Service PL </span>
                            </h4>   
                        </div>
                        <!-- <div class="col-sm-4">
                            <div class="input-group">
                                <h4 class="col-sm-8">                                  
                                    <span *ngIf="ProfitTag" class="badge badge-pill badge-primary ml-2" (click)="RecalculatePLDetail()"> Recalculate Service PL </span>
                                </h4>   
                            </div>
                        </div> -->

                    </div>

                </div>
            </div>
           
            <div class="col-sm-12">
                <table class="table ">
                    <thead>
                        <tr>
                            <th>Copy</th>
                            <th *ngIf="SaleType=='DD'" > Existing AMCV </th>
                            <th> Estimated Monthly Copy Load </th>
                            <th> Total Copy </th>  
                            <th *ngIf="ProfitTag && SpraApprovalParams.DayOneCSA"> Total Sale Value  </th>                                                     
                            <th *ngIf="!SpraApprovalParams.DayOneCSA"> Cons. Part Code </th>                    
                            <th *ngIf="!SpraApprovalParams.DayOneCSA">Cons. Total Qty Consumption</th>
                            <th *ngIf="!SpraApprovalParams.DayOneCSA">Cons. Unit Price </th>
                            <th *ngIf="ProfitTag && !SpraApprovalParams.DayOneCSA" class="pl-2">Total Sale Value</th>
                            <th *ngIf="ProfitTag">Price-Price List</th>
                            <th *ngIf="ProfitTag">Worksheet-Net Sales Price</th>
                            <th *ngIf="ProfitTag">Landed Cost-Worksheet</th>
                            <th *ngIf="ProfitTag">Book LC</th> 
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of SpraAmcvParams; let i = index;">
                            
                            <td>
                                {{item.CounterDesc}}
                                 <!-- , {{item.Qty}}  ,
                                 <span *ngFor="let item1 of item.ProductList; let i = index;">
                                    {{item1}},
                                </span>
                                 -->
                            </td>
                            <td *ngIf="SaleType=='DD'">
                                {{item?.ExistingAMCV}}
                            </td>
                            <td>
                                <input type="text" name="txtEMCL" (input)="EmclChange(item)" [disabled]="item.IsA3RatioEntered"  type="number" [(ngModel)]="item.EMCL" class="form-control mw-100">
                                <!-- {{ProfitTag}}{{ SpraApprovalParams.DayOneCSA}} -->
                            </td>
                            <td>
                                <input type="text" name="txtTotalCopy" disabled=true type="number" [(ngModel)]="item.TotalCopy" class="form-control mw-100">
                            </td>
                            <!-- <td *ngIf="ProfitTag && SpraApprovalParams.DayOneCSA">
                                <label>{{item.TotalCounterValue}}</label>
                            </td> -->
                            <td *ngIf="ProfitTag && SpraApprovalParams.DayOneCSA"  class="text-right">
                                <label class="pr-5">{{item.TotalSaleValue}}</label>
                            </td>
                          

                            <td *ngIf="!SpraApprovalParams.DayOneCSA">
                                <span class="form-group row">
                                <ng-select bindLabel="name"  placeholder="Select item" [multiple]="false" name="sctProduct" class="ngSelect250 mw-80"
                                [searchable]="true" (keyup)="onProductCodeKeypress($event,item)"  (change)="ChangeProduct(item)" [(ngModel)]="item.ProductId" >
                                <ng-option [value]="p?.productid" [disabled]="p.disabled" *ngFor="let p of ProductCodes">                                
                                    {{p?.productcode}}
                                </ng-option>
                                </ng-select>
                               &nbsp; {{item.yeild}}
                            </span>
                            </td>                    
                            <td *ngIf="!SpraApprovalParams.DayOneCSA">                                
                                <input type="text" name="txtTotalQtyConsumption"  type="number" [(ngModel)]="item.TotalQtyConsumption" class="form-control mw-100"
                                [disabled]="(item.IsTotQtyConsExists==false || item.IsTotQtyConsExists==undefined) ? false : true" (change)="ChangeProductPrice(item)">
                            </td>
                            <td *ngIf="!SpraApprovalParams.DayOneCSA">
                                <input type="text" name="txtPrice"  type="number" [(ngModel)]="item.Price" class="form-control mw-100" 
                                [disabled]="(item.IsPriceExists==false || item.IsPriceExists==undefined) ? false : true"  (change)="ChangeProductPrice(item)">
                            </td>
                            <td *ngIf="ProfitTag && !SpraApprovalParams.DayOneCSA" class="text-right">
                                <label class="pr-5">{{item.TotSaleVal| number : '1.2-2'}}</label>
                            </td>
                            <td *ngIf="ProfitTag" class="text-right">
                                <label class="pr-5">{{item.PriceList| number : '1.2-2'}}</label>
                            </td>
                            <td *ngIf="ProfitTag"  class="text-right">
                                <label class="pr-5">{{item.WorkSheetNSP| number : '1.2-2'}}</label>
                            </td>
                            <td *ngIf="ProfitTag"  class="text-right">
                                <label class="pr-5">{{item.WorkSheetLanded| number : '1.2-2'}}</label>
                            </td>
                            <td *ngIf="ProfitTag"  class="text-right">
                                <label class="pr-5">{{item.BookingLanded| number : '1.2-2'}}</label>
                            </td>
                        </tr>
                        <tr  *ngIf="ProfitTag" class="bg-highlight">                            
                            <td colspan="3" >
                            <b>Net Sale Price Released</b>
                            </td>
                          
                            <td *ngIf="SaleType=='DD'"></td>

                            <td *ngIf="SpraApprovalParams.DayOneCSA" class="text-right">
                                <label class="pr-5"><b>{{AMCVProfitablity.TotalSale| number : '1.2-2'}}</b></label>
                            </td>
                          
                            <td *ngIf="!SpraApprovalParams.DayOneCSA"></td>                    
                            <td *ngIf="!SpraApprovalParams.DayOneCSA"></td>                    
                            <td *ngIf="!SpraApprovalParams.DayOneCSA"></td>                    
                           
                            <td *ngIf="ProfitTag && !SpraApprovalParams.DayOneCSA" class="text-right">
                                <label class="pr-5"><b>{{AMCVProfitablity.GrandTotSale| number : '1.2-2'}}</b></label>
                            </td>

                            <td *ngIf="ProfitTag" class="text-right">
                                <label class="pr-5"><b>{{AMCVProfitablity.GrandTotPriceList| number : '1.2-2'}}</b></label>
                            </td>
                            <td *ngIf="ProfitTag" class="text-right">
                                <label class="pr-5"><b>{{AMCVProfitablity.TotalWSNSP| number : '1.2-2'}}</b></label> 
                            </td>
                            <td *ngIf="ProfitTag" class="text-right">
                                <label class="pr-5"><b>{{AMCVProfitablity.TotalLandedCost| number : '1.2-2'}}</b></label> 
                            </td>
                            <td *ngIf="ProfitTag" class="text-right">
                                <label class="pr-5"><b>{{AMCVProfitablity.TotalBookLC| number : '1.2-2'}}</b></label> 
                            </td>
        
        
                        </tr>
                        <tr  *ngIf="ProfitTag" class="bg-highlight">                            
                            <td colspan="3"> 
                             <b>   Service  GP (%) BEING REALISED AGAINST THIS ORDER :</b>
                            </td>
                           
                            <td *ngIf="SaleType=='DD'"></td>

                            <td *ngIf="ProfitTag && SpraApprovalParams.DayOneCSA"></td>

                            <td *ngIf="!SpraApprovalParams.DayOneCSA"></td>                    
                            <td *ngIf="!SpraApprovalParams.DayOneCSA"></td>
                            <td *ngIf="!SpraApprovalParams.DayOneCSA"></td>

                            <td *ngIf="ProfitTag && !SpraApprovalParams.DayOneCSA"></td>

                            <td *ngIf="ProfitTag" class="text-right">
                                <label class="pr-5"><b>{{AMCVProfitablity.GPriceList}}</b></label>
                            </td>
                            <td *ngIf="ProfitTag" class="text-right">
                                <label class="pr-5"><b>{{AMCVProfitablity.GPWSNSP}}</b></label> 
                            </td>
                            <td *ngIf="ProfitTag" class="text-right">
                                <label class="pr-5"><b>{{AMCVProfitablity.GPLandedCost}}</b></label> 
                            </td>
                            <td *ngIf="ProfitTag" class="text-right">
                                <label class="pr-5"><b>{{AMCVProfitablity.GPBookLC}}</b></label> 
                            </td>
        
                        </tr>
                    </tbody>
                </table>
        
            </div>
        </div>

        

    </mat-card-content>
</mat-card>